import React, { useState, useEffect } from "react";
import { Fade, Zoom } from "react-awesome-reveal";
import Learning from "./Learning/Learning";
import Service from "./Service/Service";
import "./Programme.css";

const Programme = () => {
  const [showPopup, setShowPopup] = useState(null);
  const [highlightCard, setHighlightCard] = useState(null); // "learning" | "service" | null

  // Lock body scroll when popup is open
  useEffect(() => {
    if (showPopup) {
      document.body.classList.add("programme-page-no-scroll");
    } else {
      document.body.classList.remove("programme-page-no-scroll");
    }
    return () => document.body.classList.remove("programme-page-no-scroll");
  }, [showPopup]);

  // Listen for custom highlight events from Header
  useEffect(() => {
    const handleHighlight = (e) => {
      const card = e.detail?.card; // "learning" or "service"
      if (card) {
        setHighlightCard(card);
        // Remove highlight after 2.5s
        setTimeout(() => setHighlightCard(null), 2500);
      }
    };
    window.addEventListener("programme-highlight", handleHighlight);
    return () => window.removeEventListener("programme-highlight", handleHighlight);
  }, []);

  return (
    <div className="programme-page-wrapper" id="programme">
      {/* Background elements */}
      <div className="programme-page-grid-overlay" />
      <div className="programme-page-orb programme-page-orb-1" />
      <div className="programme-page-orb programme-page-orb-2" />

      {/* Subtle Glitter */}
      <div className="programme-page-glitter-container">
        {[...Array(20)].map((_, i) => (
          <div key={i} className="programme-page-glitter-bit" />
        ))}
      </div>

      <div className="programme-page-container container">
        <Fade direction="up" duration={1000} triggerOnce>
          <header className="programme-page-header">
          <h1 className="programme-page-main-title">
              Elevate Your <em>Potential</em>
            </h1>
            <p className="programme-page-subtitle">
              Expert-led training and professional medical coding solutions tailored for healthcare excellence.
            </p>
          </header>
        </Fade>

<div className="container" >
<div className="row">
<div className="col-lg-2"></div>
<div className="col-lg-4">  <Zoom duration={1000} triggerOnce>
            <div
              className={`programme-page-card${highlightCard === "learning" ? " programme-page-card--highlighted" : ""}`}
              onClick={() => setShowPopup("learning")}
              id="programme-card-learning"
            >
              <div className="programme-page-card-inner">
                {highlightCard === "learning" && (
                  <div className="programme-page-highlight-badge">Learning</div>
                )}
                <div className="programme-page-image-box">
                  <img
                    src="https://www.iberdrola.com/documents/20125/42118/lifelong_746x419.jpg"
                    alt="Medical Coding Training"
                    className="programme-page-img"
                  />
                  <div className="programme-page-overlay-gradient" />
                </div>
                <div className="programme-page-content">
                  <h2 className="programme-page-card-title">Learning</h2>
                  <p className="programme-page-card-desc">
                    Comprehensive courses in ICD-10, CPT, and HCPCS. Master the skills needed to become a certified medical coder.
                  </p>
                  <button className="programme-page-action-btn">View Courses</button>
                </div>
              </div>
            </div>
          </Zoom></div>
<div className="col-lg-4"> <div className="programme-page-grid ">
          {/* Learning Card */}
        

          {/* Service Card */}
          <Zoom duration={1000} delay={200} triggerOnce>
            <div
              className={`programme-page-card${highlightCard === "service" ? " programme-page-card--highlighted" : ""}`}
              onClick={() => setShowPopup("service")}
              id="programme-card-service"
            >
              <div className="programme-page-card-inner">
                {highlightCard === "service" && (
                  <div className="programme-page-highlight-badge">Services</div>
                )}
                <div className="programme-page-image-box">
                  <img
                    src="https://img.freepik.com/free-vector/digital-technology-engineering-digital-telecoms-concept-futuristic-technology-background-vector-illustration_587448-1058.jpg"
                    alt="Medical Billing Services"
                    className="programme-page-img"
                  />
                  <div className="programme-page-overlay-gradient" />
                </div>
                <div className="programme-page-content">
                  <h2 className="programme-page-card-title">Services</h2>
                  <p className="programme-page-card-desc">
                    Professional medical billing and coding services designed to optimize revenue cycle management for practices.
                  </p>
                  <button className="programme-page-action-btn">Our Services</button>
                </div>
              </div>
            </div>
          </Zoom>
        </div></div>
<div className="col-lg-2"></div>
</div>
</div>





       

        {/* Modal Popup */}
        {showPopup && (
          <div
            className="programme-page-popup-overlay"
            onClick={() => setShowPopup(null)}
          >
            <div
              className="programme-page-popup-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="programme-page-close-btn"
                onClick={() => setShowPopup(null)}
                aria-label="Close"
              >
                ×
              </button>
              <div className="programme-page-popup-scroll-area">
                {showPopup === "learning" && <Learning />}
                {showPopup === "service" && <Service />}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Programme;